import BehaviourRollupView from './BehaviourRollupView'

export default BehaviourRollupView
